import { render } from "./content.vue?vue&type=template&id=649c107c&scoped=true"
import script from "./content.vue?vue&type=script&lang=js"
export * from "./content.vue?vue&type=script&lang=js"

import "./content.vue?vue&type=style&index=0&id=649c107c&scoped=true&lang=css"
import "./content.vue?vue&type=style&index=1&id=649c107c&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-649c107c"]])

export default __exports__